import type { PluginObject } from 'vue';
import type { Injector } from 'typed-inject';
import type { MainInjector } from '@/di/injector';

declare module 'vue/types/vue' {
    interface Vue {
        $injector: MainInjector;
    }
}

export default {
    install(Vue, injector: Injector<unknown>) {
        Vue.prototype.$injector = injector;
    },
} as PluginObject<Injector<unknown>>;
